<mat-toolbar>
    Server Account Manager

    <span fxFlex></span>

    <ng-container *ngIf="!(authenticated$ | async)">
        <button mat-button *ngIf="router.url !== '/auth/login'" routerLink="/auth/login">
            <mat-icon>input</mat-icon>&nbsp;Sign In
        </button>
        <button mat-button *ngIf="router.url !== '/auth/register'" routerLink="/auth/register">
            <mat-icon>person_add</mat-icon>&nbsp;Sign Up
        </button>
    </ng-container>

    <ng-container *ngIf="(authenticated$ | async) && (user$ | async)">
        <!-- <button mat-icon-button routerLink="/">
            <mat-icon>home</mat-icon>
        </button> -->

        <button mat-button (click)="logout()">
            <mat-icon>directions_run</mat-icon>
            LOGOUT
        </button>

        <!-- <button mat-icon-button [matMenuTriggerFor]="profileMenu">
            <mat-icon>menu</mat-icon>
        </button>

        <mat-menu xPosition="before" [overlapTrigger]="false" #profileMenu="matMenu" class="before">
            <p class="username">{{(user$|async)?.email}}</p>
            <mat-divider></mat-divider>

            <button mat-menu-item (click)="logout()">
                <mat-icon>exit_to_app</mat-icon>
                Exit
            </button>
        </mat-menu> -->

    </ng-container>

</mat-toolbar>

<router-outlet></router-outlet>